/**
 * AlertTimingCard
 * Grid of 6 datetime cells: Sent, Validated, Processed, Closed, Created, Updated.
 */
import React from 'react';
import {
  FiClock,
  FiCalendar,
  FiSend,
  FiShield,
  FiActivity,
  FiX,
} from 'react-icons/fi';
import { getDateTime } from '@/utils/dateTime';
import type { IAlertProps } from '@/pages/Alert/alerts.interface';
import { StatCell } from '@/components/organism/Cards/StatCell';
import { SectionCard } from '@/components/organism/Cards/SectionCard';
import { ORGANISM_PROPS } from '@/constant/global/global.constant';

const TIMING_FIELDS: {
  label: string;
  key: keyof IAlertProps;
  icon: React.ReactNode;
}[] = [
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.SENT_ON,
    key: 'sentOn',
    icon: <FiSend className="w-3 h-3 shrink-0" />,
  },
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.VALIDATED_ON,
    key: 'validatedOn',
    icon: <FiShield className="w-3 h-3 shrink-0" />,
  },
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.PROCESSED_ON,
    key: 'processedOn',
    icon: <FiActivity className="w-3 h-3 shrink-0" />,
  },
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.CLOSED_ON,
    key: 'closedOn',
    icon: <FiX className="w-3 h-3 shrink-0" />,
  },
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.CREATED_ON,
    key: 'createdOn',
    icon: <FiCalendar className="w-3 h-3 shrink-0" />,
  },
  {
    label: ORGANISM_PROPS.ALERT_TIMING_CARD.UPDATED_ON,
    key: 'updatedOn',
    icon: <FiClock className="w-3 h-3 shrink-0" />,
  },
];

export const AlertTimingCard = ({
  data,
  testId,
}: {
  data: IAlertProps;
  testId?: string;
}) => {
  return (
    <SectionCard
      testId={testId}
      title={ORGANISM_PROPS.ALERT_TIMING_CARD.SECTION_TITLE}
      icon={<FiClock className="h-3.5 w-3.5" />}
      bodyClassName=""
    >
      <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-gray-100 dark:divide-gray-700/60">
        {TIMING_FIELDS.map(({ label, key, icon }) => {
          const raw = data[key] as string | undefined;
          return (
            <StatCell
              key={label}
              label={label}
              labelIcon={icon}
              value={
                raw ? getDateTime(raw) : ORGANISM_PROPS.ALERT_TIMING_CARD.N_A
              }
            />
          );
        })}
      </dl>
    </SectionCard>
  );
};
